import type { SortedProvidersIdsToOrder } from '@bcf-vanilla-ts-v1-configurators/tokens/slots/types';

export const cpSortedProviderNamesToOrder: SortedProvidersIdsToOrder = [
  'bf-games',
  'pragmatic-play',
  'playn-go',
  'greentube',
  'games-global',
  'hacksaw',
  'bgaming',
  'booming-games',
  'relax-gaming',
  'evolution',
  'red-tiger',
  'netent',
  'blueprint',
  'nolimit-city',
  'push-gaming',
  'wazdan',
  'spinomenal',
  'swintt',
  'pg-soft',
  'btg',
  'stakelogic',
  'gaming-corps',
  'wizard-games',
  'netgaming',
  'skywind',
  'gamomat',
  'iron-dog-studios',
  'slotopia',
  'kalamba',
  'just-for-the-win',
  'thunderkick',
  'ruby-play',
  'playson',
  'pragmatic-play-live',
  'fazi',
  'elk',
  'peter-and-sons',
  'red-rake-gaming',
  'spinberry',
  'ela-games',
  'spribe',
  '1x2-gaming',
  'gamevy',
  'holle-games',
  'atomic-slot-lab',
  'slotmill',
  'ainsworth',
  'indigo-magic',
  'win-fast',
  'on-air-entertainment',
  'evoplay',
  'king-show-games',
  'raw',
  'ezugi',
  'fantasma',
  'smartsoft',
  'oryx',
  'reelplay',
  'bally-wulff',
  'leander-games',
  'stakelogic-live',
  'tornado-games',
  'spinmatic',
  'eyecon',
  'blue-guru-games',
  'betgames',
  'leap-gaming',
  'winfast'
];
